require('./angular-sanitize');
module.exports = 'ngSanitize';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-sanitize/index.js
 ** module id = 18
 ** module chunks = 0
 **/